import { render, staticRenderFns } from "./BoardWriteDefaultLayout.vue?vue&type=template&id=403df119&scoped=true&"
import script from "./BoardWriteDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./BoardWriteDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403df119",
  null
  
)

export default component.exports